import React, { useEffect, useRef } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { isAxiosError } from 'axios';
import { Heading1, Heading3 } from 'inpock-ui-react';
import queryString from 'query-string';

import { Spinner } from '@/components';
import { instance } from '@/apis';

import * as S from './styled';

export function PayCallbackPage() {
  const paymentRequested = useRef(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { version } = queryString.parse(location.search);

  useEffect(() => {
    if (paymentRequested.current) return;
    const confirmPayment = async () => {
      const requestData = {
        orderId: searchParams.get('orderId'),
        amount: searchParams.get('amount'),
        paymentKey: searchParams.get('paymentKey'),
      };

      try {
        const { status, data } = await instance.post(
          version ? `/${version}/payments` : '/payments',
          requestData,
        );

        if (status === 200) {
          const { buyer_phone, order_group_number } = data;
          navigate(
            version
              ? `/pay/callback/success?phone=${buyer_phone}&order_group_number=${order_group_number}&version=${version}`
              : `/pay/callback/success?phone=${buyer_phone}&order_group_number=${order_group_number}`,
            {
              replace: true,
            },
          );
        }
      } catch (error) {
        if (isAxiosError(error)) {
          const { response } = error; // code, message, campaign_id, username
          const failReason = response?.data.message || '';
          const campaignId = response?.data.campaign_id || '';
          const username = response?.data.username || '';

          navigate(
            version
              ? `/pay/callback/fail?fail_reason=${failReason}&campaign_id=${campaignId}&version=${version}&username=${username}`
              : `/pay/callback/fail?fail_reason=${failReason}&campaign_id=${campaignId}&username=${username}`,
            {
              replace: true,
            },
          );
        }
      }
    };

    confirmPayment();
    paymentRequested.current = true;
  }, [navigate, searchParams]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>결제 중 | 인포크링크</title>
          <meta property="og:title" content="인포크링크 - 가장 편리한 멀티링크 서비스" />
          <meta
            property="og:subscription"
            content="다양한 링크를 모으고 멋진 이야기를 들려주세요!"
          />
        </Helmet>
      </HelmetProvider>
      <S.LoadingContainer>
        <Heading1>결제 중</Heading1>
        <Heading3 fontWeight="regular" className="mb-16">
          잠시만 기다려주세요
        </Heading3>
        <Spinner size="48px" color="var(--color-ui-orangescale-orange-600)" />
      </S.LoadingContainer>
    </>
  );
}
